import React, { useState } from "react";
import emailjs from "emailjs-com";
import {
  Box,
  Typography,
  Container,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { Helmet } from "react-helmet"; // Importing react-helmet

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_d9csnqi", // Replace with your EmailJS service ID
        "template_n382k36", // Replace with your EmailJS template ID
        formData,
        "TMhedns5y0xFql6fz" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          setSuccessMessage("Your message has been sent successfully!");
          setErrorMessage("");
          setFormData({ name: "", email: "", message: "" });
        },
        (error) => {
          setErrorMessage("Something went wrong. Please try again.");
          setSuccessMessage("");
        }
      );
  };

  return (
    <Box sx={{ py: 5 }}>
      <Helmet>
        <title>Contact Us | Praise Revival Church Dharmapuri</title>
      </Helmet>
      <Container>
        {/* Page Title */}
        <Typography
          variant="h2"
          gutterBottom
          align="center"
          sx={{ fontWeight: "bold", color: "primary.main" }}
        >
          Contact Us
        </Typography>
        <Typography variant="body1" gutterBottom align="center">
          <strong>Address:</strong> Praise Revival Church, Zion Nagar, Thadangam, Dharmapuri, Tamil Nadu, India
        </Typography>
        <Typography variant="body1" gutterBottom align="center">
          <strong>Phone:</strong>{" "}
          <a href="tel:+919442825800" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            +91-9442825800
          </a>
        </Typography>
        <Typography variant="body1" gutterBottom align="center">
          <strong>Email:</strong>{" "}
          <a href="mailto:praiserevivalchurchdpi@gmail.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            praiserevivalchurchdpi@gmail.com
          </a>
        </Typography>
        <Typography variant="body1" gutterBottom align="center">
          <strong>Follow us:</strong>{" "}
          <a href="https://www.facebook.com/PraiseofRevivalchurch" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            Facebook
          </a>
          ,{" "}
          <a href="https://instagram.com/praiserevivalchurch" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            Instagram
          </a>
          ,{" "}
          <a href="https://www.youtube.com/@praiserevivalchurch9814" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
            Youtube
          </a>
        </Typography>

        {/* Contact Form */}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
          <TextField
            fullWidth
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="Message"
            name="message"
            multiline
            rows={4}
            value={formData.message}
            onChange={handleChange}
            margin="normal"
            required
          />
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Send Message
          </Button>
        </Box>

        {/* Feedback Messages */}
        {successMessage && <Alert severity="success" sx={{ mt: 2 }}>{successMessage}</Alert>}
        {errorMessage && <Alert severity="error" sx={{ mt: 2 }}>{errorMessage}</Alert>}

        {/* Map Section */}
        <Typography variant="body1" sx={{ mt: 4 }} align="center">
          <div
            style={{ width: "100%", height: "450px" }}
            dangerouslySetInnerHTML={{
              __html: `
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.981545239488!2d78.12106827584921!3d12.113415133110363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bac17809a613507%3A0x32e5e194f9f5064c!2sPraise%20Revival%20Church%20Dharmapuri%20(PRC%20DPI)!5e0!3m2!1sen!2sin!4v1732009617781!5m2!1sen!2sin" 
              width="100%" height="100%" style="border:0;" allowfullscreen="" referrerpolicy="no-referrer-when-downgrade">
            </iframe>`,
            }}
          />
        </Typography>
      </Container>
    </Box>
  );
};

export default ContactUs;
